module.exports = __webpack_public_path__ + "static/img/科学院.1134b06c.png";